import { Alert, Box, Button, Dialog, DialogContent, Grid, Snackbar, Stack, Tooltip, Typography, useMediaQuery } from '@mui/material';
import WhiteInosio from '../../../icons/whiteinosio.svg';
import BackIcon from '../../../icons/back1.svg';
import { convertCentsToDollars } from '../../util/converters';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import InputBox from '../../InputBox';
import { NumberRegex } from '../../../utils/regex';
import AddCardPaymentIcon from '../../../icons/addCardIcon.png';
import CardCircuit from '../../../icons/cardCircuit.png';
import { approvedISOStandards } from '../../util/approvedISOStandards';
import VisaLogo from '../../../icons/visa-logo.png';
import MasterCardLogo from '../../../icons/masterCardIcon.png';
import Amex from '../../../icons/AMEX.svg';
import Discover from '../../../icons/Discover.svg';
import { getBankCardTypeByPrefix, getResetBankCardType, selectPaymentRequestsState } from '../../../pmui/paymentrequests/sagas/paymentrequestslice';
import { BankCardType, CreateBankCardDTO } from '@inosio/payments-sdk';
import { getBuildBankCard, getResetBuildBankCard } from '../../../pmui/paymentrequests/sagas/paymentrequestslice';
import NumberFormat from 'react-number-format';
import HelpIcon from '@mui/icons-material/Help';
import { UNREG_DEBIT_CARD_SPECIFIC } from '../../../utils/constants';
interface AddCardModalProps {
  open: boolean;
  onContinue: (agreedUponFeeAmt: number) => void;
  onBackClick: () => void;
  CardType: string;
  Fees: { CC: number; DB: number }; //idea here is for unregulated or prepaid debits to be able to offer the credit card fee
  CompanyName: string;
}
const AddCardModal = (props: AddCardModalProps) => {
  const { open, onContinue, onBackClick, CardType, Fees, CompanyName } = props;
  const initialFeeChoice: number = CardType === 'DB' ? Fees.DB : Fees.CC;
  const { Countries: approvedCountries, States: approvedStates, Provinces: approvedProvinces } = approvedISOStandards;
  const { BankCardType: userBankcardMetaInfo } = useSelector(selectPaymentRequestsState);
  const isOnMobileScreen = useMediaQuery('(max-width:600px)');
  const dispatch = useDispatch();

  const [cardNickName, setCardNickName] = React.useState('');
  const [cardNumber, setCardNumber] = React.useState('');
  const [cardNames, setCardNames] = React.useState('');
  const [cardExpiration, setCardExpiration] = React.useState('');
  const [cardAddress, setCardAddress] = React.useState('');
  const [cardCountry, setCardCountry] = React.useState('US');
  const [cardCity, setCardCity] = React.useState('');
  const [cardState, setCardState] = React.useState('');
  const [cardZip, setCardZip] = React.useState('');
  const [cardCvv, setCardCvv] = React.useState('');
  const [cardGlobalError, setCardGlobalError] = React.useState<string | null>(null);
  //validation errors state
  const [cardNumberError, setCardNumberError] = React.useState('');
  const [cardNameError, setCardNameError] = React.useState('');
  const [cardExpirationError, setCardExpirationError] = React.useState('');
  const [cardAddressError, setCardAddressError] = React.useState('');
  const [cardZipError, setCardZipError] = React.useState('');
  const [cardCvvError, setCardCvvError] = React.useState('');
  const [cardCountryError, setCardCountryError] = React.useState('');
  const [cardCityError, setCardCityError] = React.useState('');
  const [cardStateError, setCardStateError] = React.useState('');
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);

  const OnClick = () => {
    onBackClick();
    setCardNickName('');
    setCardNumber('');
    setCardNames('');
    setCardExpiration('');
    setCardAddress('');
    setCardCity('');
    setCardZip('');
    setCardCvv('');
    setCardGlobalError('');
    setCardNumberError('');
    setCardNameError('');
    setCardExpirationError('');
    setCardAddressError('');
    setCardZipError('');
    setCardCvvError('');
    setCardCountryError('');
    setCardCityError('');
    setCardStateError('');
    dispatch({
      type: getResetBuildBankCard.type,
    });
    dispatch({
      type: getResetBankCardType.type,
    });
  };

  const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarOpen(false);
  };

  const onChangeCardNumberHandler = (e: any) => {
    if (e.target.value === '' || NumberRegex.test(e.target.value)) {
      setCardNumber(e.target.value);
    }
  };

  const onChangeCardCvcNumberHandler = (e: any) => {
    if (e.target.value === '' || NumberRegex.test(e.target.value)) {
      setCardCvv(e.target.value);
    }
  };

  const setCardExpirationHandler = (expiration: any) => {
    setCardExpiration(expiration);
    if (expiration.length === 2 && !expiration.includes('/')) {
      setCardExpiration([expiration.slice(0, 2), '/', expiration.slice(2)].join(''));
    }
  };

  const validateCardNumber = () => {
    if (cardNumber.length < 13) {
      setCardNumberError('Card number is incomplete!');
      return false;
    } else if (cardNumber.length !== 16 && (userBankcardMetaInfo?.CardNetwork === 'visa' || userBankcardMetaInfo?.CardNetwork === 'mastercard')) {
      setCardNumberError('Card should be 16 digits');
      setCardGlobalError('Card should be 16 digits');
      setSnackBarOpen(true);
      return false;
    } else if (cardNumber.length !== 15 && userBankcardMetaInfo?.CardNetwork === 'amex') {
      setCardNumberError('Card should be 15 digits');
      setCardGlobalError('Card should be 15 digits');
      setSnackBarOpen(true);
      return false;
    } else {
      setCardNumberError('');
      setCardGlobalError('');
      setSnackBarOpen(false);
      return true;
    }
  };
  const validateCardNames = () => {
    if (cardNames.length === 0) {
      setCardNameError('Card name is empty!');
      return false;
    } else if (cardNames.split(' ')?.length === 1) {
      setCardGlobalError('First and last name are required.');
      setCardNameError('First and last name are required.');
      return false;
    } else {
      setCardNameError('');
      return true;
    }
  };
  const validateCardExpiration = () => {
    if (cardExpiration.length === 0) {
      setCardExpirationError('Card expiration date is empty!');
      return false;
    } else if (cardExpiration.length !== 7) {
      setCardExpirationError('Wrong expiration date!');
      return false;
    } else {
      setCardExpirationError('');
      return true;
    }
  };
  const validateCardAddress = () => {
    if (cardAddress.length === 0) {
      setCardAddressError('Card address is empty!');
      return false;
    } else {
      setCardAddressError('');
      return true;
    }
  };
  const validateCardZip = () => {
    if (cardZip.length === 0) {
      setCardZipError('Card ZIP code is empty!');
      return false;
    } else {
      setCardZipError('');
      return true;
    }
  };
  const validateCardCvv = () => {
    if (cardCvv.length === 0) {
      setCardCvvError('Card CVV code is empty!');
      return false;
    } else {
      setCardCvvError('');
      return true;
    }
  };
  const validateCardCountry = () => {
    if (cardCountry.length === 0) {
      setCardCountryError('Card country is empty!');
      return false;
    } else {
      setCardCountryError('');
      return true;
    }
  };
  const validateCardCity = () => {
    if (cardCity.length === 0) {
      setCardCityError('Card city is empty!');
      return false;
    } else {
      setCardCityError('');
      return true;
    }
  };
  const validateCardState = () => {
    if (cardState.length === 0) {
      setCardStateError('Card state is empty!');
      return false;
    } else {
      setCardStateError('');
      return true;
    }
  };

  const validateBankCardType = () => {
    if (userBankcardMetaInfo?.CardType === 'CC' && CardType === 'DB') {
      setCardGlobalError('You have entered a Credit Card number, Please enter a valid Debit Card number.');
      setSnackBarOpen(true);
      return false;
    } else if (userBankcardMetaInfo?.CardType === 'DB' && CardType === 'CC') {
      setCardGlobalError('You have entered a Debit Card number, Please enter a valid Credit Card number');
      setSnackBarOpen(true);
      return false;
    } else if (userBankcardMetaInfo?.CardType.length === 0) {
      setCardGlobalError('Invalid card number');
      setSnackBarOpen(true);
      return false;
    } else {
      setCardGlobalError('');
      return true;
    }
  };

  const handleAddCardSubmit = () => {
    const names = cardNames.split(' ');
    if (validateCardNumber() && validateBankCardType() && validateCardCvv() && validateCardNames() && validateCardExpiration() && validateCardAddress() && validateCardCity() && validateCardState() && validateCardZip() && validateCardCountry()) {
      dispatch({
        type: getBuildBankCard.type,
        payload: {
          CardNumber: cardNumber,
          SecurityCode: cardCvv,
          BillingAddress: {
            City: cardCity,
            State: cardState,
            Zip: cardZip,
            Line1: cardAddress,
            Country: cardCountry,
          },
          ExpirationDate: cardExpiration.split('/').join(''),
          CardholderFirstname: names[0],
          CardholderLastname: names[1],
          NickName: cardNickName,
        } as CreateBankCardDTO,
      });
      onContinue(updatedFeeChoice);
    }
  };

  React.useEffect(() => {
    if (cardNumber.length >= 6) {
      dispatch({
        type: getBankCardTypeByPrefix.type,
        payload: {
          cardPrefix: cardNumber,
        },
      });
    }
  }, [dispatch, cardNumber]);

  const isDebitProcessingAsCredit = userBankcardMetaInfo != null && userBankcardMetaInfo?.ProcessAsCardType !== BankCardType.Db && props.CardType === 'DB';
  const updatedFeeChoice = isDebitProcessingAsCredit ? Fees.CC : initialFeeChoice;
  const style = {
    height: isOnMobileScreen ? '100%' : '523px',
  };
  return (
    <Dialog
      open={open}
      fullScreen={isOnMobileScreen}
      BackdropProps={{
        invisible: true,
      }}
      fullWidth={true}
      disableEnforceFocus
      style={{
        background: 'none',
      }}
      PaperProps={{
        style: {
          pointerEvents: 'auto',
          borderRadius: isOnMobileScreen ? '0px' : '24px',
          width: isOnMobileScreen ? '100%' : '472px',
          boxShadow: 'none',
          overflow: 'hidden',
        },
      }}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <Box sx={style}>
          <Grid container display="flex" flexDirection="column">
            {isOnMobileScreen ? (
              <Grid item display="flex" justifyContent="center">
                <Grid item display="flex" pl={4} sx={{ width: '340px' }}>
                  <img src={WhiteInosio} style={{ width: '75px', height: '75px' }} alt="logo" />
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '18px',
                      lineHeight: '23px',
                      color: '#14142B',
                      textAlign: 'left',
                      padding: '15px',
                    }}
                  >
                    {CompanyName}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
            <Typography
              sx={{
                fontFamily: 'Work Sans',
                fontStyle: 'normal',
                fontWeight: 700,
                fontSize: '18px',
                lineHeight: '23px',
                color: '#14142B',
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px',
              }}
            >
              Add a card
            </Typography>
            <Stack direction="column" justifyContent="start" alignItems="space-between" spacing={1} mt={isOnMobileScreen ? 3 : 0}>
              <Stack
                direction="column"
                justifyContent="space-between"
                alignItems="space-between"
                spacing={2}
                style={{
                  borderRadius: '24px',
                  background: CardType === 'DB' ? '#F59D79' : 'linear-gradient(to right,  rgba(162, 219, 250, 0.7) ,rgba(57, 162, 219, 0.7))',
                  width: isOnMobileScreen ? '300px' : '319px',
                  margin: '0 auto',
                  marginBottom: '10px',
                  padding: '16px',
                }}
              >
                <Stack direction="row" spacing={25}>
                  <div>
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: 'normal',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: ' 18px',
                        textTransform: 'capitalize',
                        color: ' #FFFFFF',
                      }}
                    >
                      {CardType === 'DB' ? 'Debit Card' : CardType === 'CC' ? 'Credit Card' : 'Card'}
                    </Typography>
                  </div>
                  <div>
                    {userBankcardMetaInfo?.CardNetwork?.toLowerCase() === 'mastercard' ? (
                      <img src={MasterCardLogo} alt="Master" style={{ width: '15px', height: '12px' }} />
                    ) : userBankcardMetaInfo?.CardNetwork?.toLowerCase() === 'visa' ? (
                      <img src={VisaLogo} alt="card" style={{ width: '29px', height: '9px' }} />
                    ) : ["amex","american express"].includes(userBankcardMetaInfo?.CardNetwork?.toLowerCase()||"")? (
                      <img src={Amex} alt="card" style={{ width: '29px', height: '9px' }} />
                    ) : userBankcardMetaInfo?.CardNetwork?.toLowerCase() === 'discover' ? (
                      <img src={Discover} alt="card" style={{ width: '29px', height: '9px' }} />
                    ) : (
                      <img src={AddCardPaymentIcon} alt="card" style={{ width: '15px', height: '12px', marginBottom: '10px' }} />
                    )}
                  </div>
                </Stack>
                <Stack direction="row" justifyContent="start" alignItems="start" spacing={8.5}>
                  <div>
                    <InputBox label="Nickname" name="name" style={{ width: '165px' }} placeholder="" value={cardNickName} onChange={(e: any) => setCardNickName(e.target.value)} type="text" />
                  </div>
                  <div>
                    <InputBox label="CVC" style={{ width: '60px', height: '32px' }} placeholder="" name="cvc" value={cardCvv} onChange={onChangeCardCvcNumberHandler} type="text" error={cardCvvError} />
                  </div>
                </Stack>
                <div>
                  <img src={CardCircuit} alt="" />
                </div>
                <Stack direction="row" justifyContent="start" alignItems="start" spacing={2}>
                  <div style={{ marginBottom: '5px' }}>
                    <InputBox label="Card Number" style={{ width: isOnMobileScreen ? '300px' : '310px' }} name="card-number" placeholder="" value={cardNumber} onChange={onChangeCardNumberHandler} error={cardNumberError} type="text" />
                  </div>
                </Stack>
                <Stack direction="row" justifyContent="space-between" alignItems="space-between" spacing={4}>
                  <div style={{ marginBottom: '5px' }}>
                    <InputBox label="Name on card" name="full-name" style={{ width: '180px', borderRadius: '24px' }} placeholder="" value={cardNames} onChange={(e: any) => setCardNames(e.target.value)} error={cardNameError} type="text" />
                  </div>
                  <div style={{ marginBottom: '5px', marginLeft: '20px' }}>
                    <InputBox label="EXP" name="exp" style={{ width: '95px' }} placeholder="MM/YYYY" value={cardExpiration} onChange={(e: any) => setCardExpirationHandler(e.target.value)} error={cardExpirationError} type="text" maxLength={7} />
                  </div>
                </Stack>
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
                style={{
                  marginBottom: '5px',
                }}
              >
                <input
                  placeholder="Address"
                  style={{
                    border: '1px solid #F1F0F5',
                    borderRadius: '24px',
                    height: '8px',
                    width: isOnMobileScreen ? '300px' : '382px',
                    margin: '0 auto',
                    padding: '15px',
                    borderTop: cardAddressError.length ? '2px  solid #DB3939' : '1px solid #F1F0F5',
                  }}
                  value={cardAddress}
                  onChange={(e) => setCardAddress(e.target.value)}
                  type="text"
                  name="address"
                />
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
                style={{
                  marginBottom: '5px',
                }}
              >
                <div>
                  <input
                    placeholder="City"
                    name="city"
                    type="text"
                    style={{
                      border: '1px solid #F1F0F5',
                      borderRadius: '24px',
                      height: '8px',
                      width: isOnMobileScreen ? '145px' : '188px',
                      padding: '15px',
                      borderTop: cardCityError.length ? '2px  solid #DB3939' : '1px solid #F1F0F5',
                    }}
                    value={cardCity}
                    onChange={(e) => setCardCity(e.target.value)}
                  />
                </div>
                <div placeholder="State">
                  <select
                    placeholder="State"
                    name="state"
                    style={{
                      border: '1px solid #F1F0F5',
                      borderRadius: '24px',
                      height: '41px',
                      width: isOnMobileScreen ? '145px' : '188px',
                      padding: '0 15px',
                      borderTop: cardStateError.length ? '2px  solid #DB3939' : '1px solid #F1F0F5',
                    }}
                    defaultValue={''}
                    onChange={(e) => setCardState(e.target.value)}
                  >
                    <option style={{ height: '36px' }} value="">
                      {`Select State`}
                    </option>
                    {cardCountry === 'US' ? (
                      approvedStates.map((stateRecord) => (
                        <option style={{ height: '41px' }} key={stateRecord.Code} value={stateRecord.Code}>
                          {stateRecord.State + ' - ' + stateRecord.Code}
                        </option>
                      ))
                    ) : cardCountry === 'CA' ? (
                      approvedProvinces.map((provinceRecord) => (
                        <option style={{ height: '41px' }} key={provinceRecord.Code} value={provinceRecord.Code}>
                          {provinceRecord.Province + ' - ' + provinceRecord.Code}
                        </option>
                      ))
                    ) : (
                      <option style={{ height: '41px' }} value="NA">
                        other
                      </option>
                    )}
                  </select>
                </div>
              </Stack>
              <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                <input
                  placeholder="ZIP"
                  style={{
                    border: '1px solid #F1F0F5',
                    borderRadius: '24px',
                    height: '8px',
                    width: isOnMobileScreen ? '145px' : '188px',
                    padding: '15px',
                    borderTop: cardZipError.length ? '2px  solid #DB3939' : '1px solid #F1F0F5',
                  }}
                  name="zip"
                  type="text"
                  value={cardZip}
                  onChange={(e) => setCardZip(e.target.value)}
                />
                <div placeholder="Country">
                  <select
                    placeholder="Country"
                    name="country"
                    style={{
                      border: '1px solid #F1F0F5',
                      borderRadius: '24px',
                      height: '41px',
                      width: isOnMobileScreen ? '145px' : '188px',
                      padding: '0 15px',
                      borderTop: cardCountryError.length ? '2px  solid #DB3939' : '1px solid #F1F0F5',
                    }}
                    defaultValue="US"
                    onChange={(e) => {
                      setCardCountry(e.target.value);
                      setCardState('');
                    }}
                  >
                    {approvedCountries.map((countryRecord) => (
                      <option style={{ height: '36px' }} key={countryRecord.Code} value={countryRecord.Code}>
                        {countryRecord.Country + ' - ' + countryRecord.Code}
                      </option>
                    ))}
                  </select>
                </div>
              </Stack>
              <Grid container rowSpacing={2}>
                <Grid item sm={9}>
                  {initialFeeChoice !== 0 ? (
                    <Grid item ml={1.5} display="flex" alignItems="center">
                      <Typography style={{ fontSize: '16px', marginRight: '8px' }}>
                        fee
                        {(isDebitProcessingAsCredit && updatedFeeChoice!== initialFeeChoice) && (
                          <Tooltip leaveTouchDelay={5000} enterTouchDelay={0} title={UNREG_DEBIT_CARD_SPECIFIC} placement="bottom">
                            <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
                          </Tooltip>
                        )}
                        :
                      </Typography>
                      <NumberFormat thousandsGroupStyle="thousand" value={convertCentsToDollars(updatedFeeChoice)} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                      {!userBankcardMetaInfo && (<>&nbsp;-&nbsp;
                      <NumberFormat thousandsGroupStyle="thousand" value={convertCentsToDollars(props.Fees.CC)} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                      </>)}
                    </Grid>
                  ) : (
                    <></>
                  )}
                </Grid>
                <Grid item xs={12} sm={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    style={{
                      borderRadius: '24px',
                      textTransform: 'capitalize',
                      color: 'white',
                      backgroundColor: '#39A2DB',
                      borderColor: '#39A2DB',
                      height: '49',
                      width: isOnMobileScreen ? '300px' : '99px',
                    }}
                    variant="contained"
                    id="add-bank-btn"
                    onClick={handleAddCardSubmit}
                  >
                    Continue
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        </Box>
        <Grid item sx={{ position: 'absolute', top: isOnMobileScreen ? 116 : 40, left: 15 }}>
          <img src={BackIcon} alt="back" style={{ cursor: 'pointer' }} onClick={OnClick} />
        </Grid>
      </DialogContent>
      <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={snackBarOpen} autoHideDuration={4000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity="error">
          {cardGlobalError}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default AddCardModal;
